export class FetchModuleSlack {
    static readonly type = '[Module] FetchModuleSlack';

    constructor(
        public payload: {
            moduleId: string;
        }
    ) {}
}
